/*
 * @右侧内容重构copy
 * @Date:   2017-11-30 15:29:05
 * @Author:   yu
 */

'use strict';
angular.module('robotPrevDetailModule', [])
    .directive('robotPrevDetail', ["$state", "$location", "$timeout", '$stateParams', 'trsHttpService', 'trsspliceString', 'resourceCenterService', 'modalDialog', 'resCtrModalService', 'storageListenerService',
        function($state, $location, $timeout, $stateParams, trsHttpService, trsspliceString, resourceCenterService, modalDialog, resCtrModalService, storageListenerService) {
            return {
                scope: {
                    rebuildData: '=',
                    reflashCallback: '&'
                },
                restrict: 'AE',
                templateUrl: './networkResource/featuredResource/robot/quickPreview/detail/detail_tpl.html',
                replace: true,
                link: function(scope, iElm, iAttrs, controller) {
                    initStatus();
                    initData();
                    /**
                     * [initStatus description]状态初始化
                     * @return {[type]} [description]
                     */
                    function initStatus() {
                        scope.status = {
                            currModule: "jqrg",
                            hasPicture: false, //地震稿件是否自带图片
                            isTyphoon: false //是否为台风稿件
                        };
                        scope.basicParams = {
                            channelName: scope.status.currModule,
                            typeName: $stateParams.typename,
                            nodeId: $stateParams.nodeid
                        };
                        scope.detailData = [];
                    }
                    /**
                     * [initData description]初始化数据
                     * @return {[type]} [description]
                     */
                    function initData() {
                        if (angular.isDefined(scope.rebuildData)) {
                            requestData();
                        }
                    }
                    /**
                     * [requestData description]获取数据
                     * @return {[type]} [description]
                     */
                    function requestData() {
                        var params = {
                            "typeid": "zyzx",
                            "serviceid": "robotNews",
                            "modelid": "detail",
                            "nid": scope.rebuildData.nid
                        }
                        scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
                            if (data.message == "success") {
                                scope.detailData = data.content[0];
                                // var date = new Date(Date.parse(scope.detailInfos.updatetime));
                                // scope.detailInfos.updatetime = $filter("date")(date, "yyyy-MM-dd HH:mm:ss").toString();
                                scope.status.hasPicture = data.content[0].CONTENT.indexOf("<img src=") > -1 ? false : true;
                                if (data.content[0].modName == "地震") {
                                    earthquakeChart(data.content[0].nid);
                                } else if (data.content[0].modName == "台风新闻") {
                                    typhoonChart(data.content[0].nid);
                                } else {
                                    scope.status.hasPicture = false;
                                }
                            }
                        });
                    };
                    /**
                     * [earthquakeChart description] 加载地震新闻的图片
                     * @param  {[type]} nid [description]
                     * @return {[type]}     [description]
                     */
                    function earthquakeChart(nid) {
                        var params = {
                            typeid: "zyzx",
                            serviceid: "robotNews",
                            modelid: "earthquake",
                            nid: nid
                        };
                        require([
                            'echarts',
                            './lib/echarts/dist/echarts.min',
                            './lib/echarts/dist/china.js'
                        ], function(echarts) {
                            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
                                if (data == null || data == "") {
                                    scope.status.hasPicture = false;
                                    return;
                                }
                                var option = {
                                    title: {
                                        text: '地震分布'
                                    },
                                    tooltip: {
                                        trigger: 'item'
                                    },
                                    geo: {
                                        map: 'china',
                                        label: {
                                            emphasis: {
                                                show: false
                                            }
                                        },
                                        roam: false,
                                        itemStyle: {
                                            normal: {
                                                areaColor: '#FCCE10'
                                            }
                                        }
                                    },
                                    series: [{
                                        name: '中国',
                                        type: 'scatter',
                                        coordinateSystem: 'geo',
                                        animation: false,
                                        blurSize: 50,
                                        data: data
                                    }]
                                };
                                if (scope.status.hasPicture) {
                                    var myChart = echarts.init(document.getElementsByClassName("detail_content_picture")[0]);
                                    myChart.setOption(option);
                                    window.onresize = myChart.resize;
                                    //var img = new Image();
                                    var img = myChart.getDataURL({
                                        type: "png",
                                        pixelRatio: 1
                                    });
                                    getImage(nid, img);
                                }

                            });
                        });
                    }
                    /**
                     * [typhoonChart description] 加载台风新闻的图片
                     * @param  {[type]} nid [description]
                     * @return {[type]}     [description]
                     */
                    function typhoonChart(nid) {
                        var params = {
                            typeid: "zyzx",
                            serviceid: "robotNews",
                            modelid: "typhoon",
                            nid: nid
                        };
                        require(['echarts',
                            './lib/echarts/dist/echarts.min',
                            './lib/echarts/map/js/world.js'
                        ], function(echarts) {
                            scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
                                if (data == null || data == "") {
                                    scope.status.hasPicture = false;
                                    return;
                                }
                                scope.status.isTyphoon = true;
                                var map_data = data[0].points.map(function(element, index) {
                                    return [element.longitude, element.latitude];
                                });
                                var option = {
                                    // title: {
                                    //     text: '台风轨迹',
                                    //     left: 'center',
                                    //     textStyle: {
                                    //         color: 'black'
                                    //     },
                                    //     subtext: '(此图仅供浏览，不能被取稿)',
                                    //     subtextStyle: {
                                    //         color: 'red',
                                    //         fontSize: 14
                                    //     }
                                    // },
                                    tooltip: {
                                        trigger: 'item'
                                    },
                                    toolbox: {
                                        show: true,
                                        feature: {
                                            dataZoom: {
                                                yAxisIndex: 'none'
                                            },
                                            dataView: { readOnly: false },
                                            magicType: { type: ['line', 'bar'] },
                                            restore: {},
                                            saveAsImage: {}
                                        }
                                    },
                                    geo: {
                                        //top: 120,
                                        map: 'world',
                                        roam: true,
                                        center: [114.3896, 30.6628],
                                        zoom: 4,
                                        nameMap: {
                                            'China': '中国'
                                        },
                                        label: {
                                            normal: {
                                                show: true
                                            },
                                            emphasis: {
                                                show: true
                                            }
                                        },
                                        regions: [{
                                            name: '中国',
                                            itemStyle: {
                                                normal: {
                                                    areaColor: '#FFE680',
                                                    borderColor: '#404a59'
                                                },
                                                emphasis: {
                                                    areaColor: '#2a333d'
                                                },
                                            }
                                        }]
                                    },
                                    series: [{
                                        name: '台风轨迹',
                                        type: 'lines',
                                        polyline: true, // 连续坐标
                                        zlevel: 1,
                                        effect: {
                                            show: true,
                                            constantSpeed: 80,
                                            symbol: 'circle',
                                            symbolSize: 5,
                                            color: 'red',
                                            trailLength: 0.7
                                        },
                                        lineStyle: {
                                            normal: {
                                                color: '#a6c84c',
                                                width: 0,
                                                curveness: 0.2
                                            }
                                        },
                                        data: [{ coords: map_data }],
                                        animation: true
                                    }, {
                                        type: 'effectScatter',
                                        coordinateSystem: 'geo',
                                        zlevel: 2,
                                        rippleEffect: {
                                            brushType: 'stroke'
                                        },
                                        label: {
                                            normal: {
                                                show: true,
                                                position: 'right',
                                                formatter: '{b}'
                                            }
                                        },
                                        symbolSize: 5,
                                        itemStyle: {
                                            normal: {
                                                color: '#0066B2'
                                            }
                                        },
                                        data: [
                                            { name: '北京', value: [116.4551, 40.2539] },
                                            { name: '上海', value: [121.4648, 31.2891] },
                                            { name: '广州', value: [113.5107, 23.2196] },
                                            { name: '深圳', value: [114.5435, 22.5439] },
                                            { name: '南宁', value: [108.479, 23.1152] },
                                            { name: '海口', value: [110.3893, 19.8516] },
                                            { name: '福州', value: [119.4543, 25.9222] },
                                            { name: '厦门', value: [118.1689, 24.6478] },
                                            { name: '南昌', value: [116.0046, 28.6633] },
                                            { name: '长沙', value: [113.0823, 28.2568] },
                                            { name: '武汉', value: [114.3896, 30.6628] },
                                            { name: '杭州', value: [119.5313, 29.8773] },
                                            { name: '温州', value: [120.498, 27.8119] },
                                            { name: '台北', value: [121.5365, 25.0192] }
                                        ]
                                    }]
                                };
                                if (scope.status.hasPicture) {
                                    var myChart = echarts.init(document.getElementsByClassName("detail_content_picture")[0]);
                                    myChart.setOption(option);
                                }

                            });
                        });
                    }
                    /**
                     * [getImage description] 图片上传服务
                     * @param  {[type]} nid [description]
                     * @param  {[type]} img [description]
                     * @return {[type]}     [description]
                     */
                    function getImage(nid, img) {
                        var params = {
                            typeid: "zyzx",
                            serviceid: "robotNews",
                            modelid: "image",
                            nid: nid,
                            image: img
                        };
                        scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post');
                    }
                    /**
                     * [openTakeDraftModal description]取稿
                     * @return {[type]} [description]
                     */
                    scope.openTakeDraftModal = function() {
                        var params = {
                            serviceid: "mlf_bigdataexchange",
                            methodname: "fetch",
                            guid: scope.rebuildData.nid,
                            indexName: "",
                            channelName: scope.status.currModule,
                            IsRobot: true
                        };
                        var modalInstance = resCtrModalService.fullTakeDraft(params, false, [scope.rebuildData]);
                        modalInstance.result.then(function(data) {
                            takeDraftDownloadImgs(data).then(function() {
                                storageListenerService.addListenerToResource("takeDraft");
                            });
                        }, function() {});
                    };
                    /**
                     * [takeDraftDownloadImgs description]  图片正在下载中情况，跳转至下载弹窗
                     * @param  {[type]} data [description]
                     * @return {[type]}      [description]
                     */
                    function takeDraftDownloadImgs(data) {
                        var deferred = $q.defer();
                        var needDownloadImg = false;
                        for (var i = 0; i < data.REPORTS.length; i++) {
                            if (data.REPORTS[i].PICERROR == 1) {
                                needDownloadImg = true;
                                break;
                            }
                        }
                        if (needDownloadImg) {
                            resCtrModalService.takeDraftDownloadImgs(data, function(res) {
                                deferred.resolve();
                            });
                        } else {
                            deferred.resolve();
                        }
                        return deferred.promise;
                    }
                    //个人素材
                    /*scope.creationAxis = function() {
                        var params = angular.copy(scope.basicParams);
                        params.guid = scope.rebuildData.guid;
                        params.indexName = scope.rebuildData.indexName;
                        resourceCenterService.setBigDataCreation(params).then(function(data) {
                            modalDialog.alertType("添加成功", "", "success", false, function() {

                            });
                        });
                    };*/
                    //个人素材(稿件批量添加到个人素材)
                    scope.creationAxis = function() {
                        var params = {
                            typeid: "zyzx",
                            serviceid: "mlf_bigdataexchange",
                            methodname: "batchPersonalMaterial",
                            channelName: scope.status.currModule, //栏目名称全拼结构
                            PersonalMaterialId: 0, //所属文件夹ID，默认根节点（0）
                            indexName: "",
                            guid: scope.rebuildData.nid,
                            IsRobot: true //机器人稿必传
                        };
                        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                            modalDialog.alertType("添加成功", "", "success", false, function() {

                            });
                        });
                    };
                    // 收藏
                    scope.collect = function() {
                        var params = {
                            serviceid: "mlf_bigdataexchange",
                            methodname: "collect",
                            guid: scope.rebuildData.nid,
                            indexName: "",
                            channelName: scope.status.currModule,
                            IsRobot: true
                        };
                        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
                            modalDialog.alertType("收藏成功!", "", "success", false, "");
                        });
                    };
                    /**
                     * [plainView description] 返回 普通视图
                     * @return {[type]} [description]
                     */
                    scope.plainView = function() {
                        $state.go("front.networksource.featuredresource.robot.resource", $stateParams);
                    };
                }
            };
        }
    ]);
